// src/com/veh_info/VehInfoLine.js
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle } from '../../value/AppConst';
import { SorterLabel } from '../../common/SorterLabel';

const LineBox = styled(Box)({
    borderBottom: AppStyle.BorderCCC,
    display: 'flex', alignItems: 'start', // padding: '0.1rem 0 0.3rem 0',
    minHeight: 34, boxSizing: 'border-box',
});

const Field = styled(Box)({
    display: 'flex', alignItems: 'center', padding: '0.4rem',
});


/**
 * 차량선택을 위한 테이블의 한 줄
 */
export default function VehInfoLine({
    item,
    index,
    itemSelected,
    onClick,
    onClickSorter, // (id, sortState) => void
    idSorted, // id of the column that is currently sorted
}) {
    const [isVisible, setIsVisible] = useState(false);
    const itemRef = useRef(null);
    const bgColor = useMemo(()=>{
        if(item) {
            if(itemSelected && item.vehInfoSeq===itemSelected.vehInfoSeq) {
                return '#d0f7ff';
            }
            return index % 2 === 0 ? '#ffffff' : '#f9f9f9';
        }
        return '#ffffff';
    }, [item, itemSelected, index]);
    const windowWidth = window.innerWidth;
    const driverWidth = windowWidth * 0.2;
    const mobileWidth = windowWidth * 0.35;
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // Update state when intersection status changes
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null, // viewport
                rootMargin: '0px',
                threshold: 0.1, // trigger when 10% of the element is visible
            }
        );

        const currentRef = itemRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        // Cleanup observer on component unmount
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const renderLine = () => {
        return(
            <>
            <Field style={{
                flexGrow: 1
            }}>
                {item.vehPlates}
            </Field>
            <Field style={{width:driverWidth, minWidth:driverWidth}}>{item.driverName}</Field>
            <Field style={{width:mobileWidth, minWidth:mobileWidth}}>{item.driverMobile}</Field>
            </>
        );
    };

    if(!item) {
        // header
        return(
            <LineBox
                style={{
                    backgroundColor: AppStyle.SecondaryRGB, color: 'white',
                }}
            >
                <Field style={{flexGrow: 1, borderRight: '1px solid #ccc'}}>
                    <SorterLabel
                        id="vehPlates"
                        label="차량번호"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </Field>
                <Field style={{width:driverWidth, minWidth:driverWidth, borderRight: '1px solid #ccc'}}>
                    <SorterLabel
                        id="driverName"
                        label="운전기사"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </Field>
                <Field style={{width:mobileWidth, minWidth:mobileWidth}}>
                    <SorterLabel
                        id="driverMobile"
                        label="운전기사 연락처"
                        onClick={onClickSorter}
                        idSorted={idSorted}
                    />
                </Field>
            </LineBox>
        )
    }

    return(
        <LineBox
            ref={itemRef}
            onClick={() => {
                onClick(item);
            }}
            style={{
                backgroundColor: bgColor,
            }}
        >
            {isVisible ? renderLine() : null}
        </LineBox>
    );
}